import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import * as actions from '../actions/TrainingTypes';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import GridHeader from '../components/common/GridHeader';
import DeleteConfirmation from '../components/MultiDeleteConfirmation';
import Breadcrumb from '../components/AdminBreadcrumb';
import { DataGrid } from '@mui/x-data-grid';

const TrainingTypes = (props) => {

    const [deleteConfirmationState, setDeleteConfirmationState] = useState({
        display: false,
        toDelete: [],
    });
    const [deleteEnabled, setDeleteEnabled] = useState(false);

    useEffect(() => {
        props.actions.getTrainingTypes();
    }, []);

    const handleAddClick = (e) => {
        props.actions.newTrainingType();
        props.history.push({
            pathname: `/trainingtypes/trainingType`
        });
    }

    const handleSelectionChanged = (e) => {
        if (e.length > 0) {
            setDeleteConfirmationState({
                display: false,
                toDelete: props.trainingTypes.toJS().filter(x => e.find(y => y === x.trainingTypeId)),
            });
            setDeleteEnabled(true);
        }
        else
            setDeleteEnabled(false);
    }

    const handleDeleteClick = (e) => {
        setDeleteConfirmationState({
            display: true,
            toDelete: deleteConfirmationState.toDelete
        });
    }

    const handleSelect = (e) => {
        props.actions.getTrainingType(e.id);
        props.history.push(`/trainingtypes/trainingtype/${e.id}`, { id: e.id })

    };

    const handleDeleteConfirmationToggle = () => setDeleteConfirmationState({
        display: !deleteConfirmationState.display,
        toDelete: deleteConfirmationState.toDelete
    });

    const handleDelete = () => {
        props.actions.deleteTrainingTypes(deleteConfirmationState.toDelete.map(x => x.trainingTypeId));
        setDeleteConfirmationState({
            display: false,
            toDelete: [],
        });
    }

    return (
        <Container>
            <div style={{ paddingBottom: '10px' }}>
                <Breadcrumb history={props.history} />
            </div>
            <Row className='mb-1'>
                <GridHeader
                    gridEntities='Training Types'
                    deleteButtonId='deleteTrainingButton'
                    disableDelete={!deleteEnabled}
                    onDeleteClick={handleDeleteClick}
                    addButtonId='addTrainingButton'
                    onAddClick={handleAddClick}
                    addTooltipTarget={'addTrainingButton'}
                    deleteTooltipTarget={'deleteTrainingButton'}
                    tooltipEntity={'Training Type'}
                />
            </Row>
            <Row className='mb-1'>
                <Col>
                    <div className='ag-theme-balham' style={{ width: 'auto' }}>
                        <DataGrid

                            rows={props.trainingTypes.toJS().map(x => { return { id: x.trainingTypeId, ...x } })}
                            checkboxSelection
                            onRowDoubleClick={handleSelect}
                            onRowSelectionModelChange={handleSelectionChanged}
                            autoHeight={true}
                            rowHeight={35}
                            initialState={{
                                pagination: { paginationModel: { pageSize: 25 } },
                            }}
                            columns={[
                                {
                                    headerName: 'Name',
                                    field: 'name',
                                    flex: 3,
                                },
                                {
                                    headerName: 'Description',
                                    field: 'description',
                                    flex: 3,
                                }
                            ]}
                            sx={{
                                backgroundColor: 'white'
                            }}
                            getRowClassName={(params) => 'grid-row'}
                        />
                    </div>
                </Col>
            </Row>
            <DeleteConfirmation
                title={`Delete Training Type`}
                onDelete={handleDelete}
                onToggle={handleDeleteConfirmationToggle}
                toDelete={deleteConfirmationState.toDelete.map(x => x.name)}
                isOpen={deleteConfirmationState.display}
            />
        </Container>
    );
}

function mapStateToProps(state, ownProps) {
    return {
        trainingTypes: state.TrainingTypes
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions }, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(TrainingTypes);